import { combineReducers } from 'redux';

import institute from './InstituteReducer';
import branch from './BranchReducer';
import student from './StudentReducer';
import payments from './PaymentsReducer';
import registration from './RegistrationReducer';
import uiConfig from './UIConfigReducer';
import global from '../reducer/GlobalReducer';

const reducer = combineReducers({
    institute,
    branch,
    student,
    payments,
    registration,
    uiConfig,
    global
});

export default reducer;